<style scoped>
  .user-volunteer {
    background: #fff;
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
  }
  .user-volunteer > .user-holder{
    display: flex;
    max-width: 240px;
  }

  .user-holder > .avatar{
    margin-right: 10px;
  }

  .user-info{
    overflow: hidden;
  }

  .user-info > h3{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .pending-volunteer-holder{
    background: #fff;
    padding: 15px;
  }

  .pending-volunteer-holder > h3{
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
  }

  .action-buttons > .reject{
    margin-right: 10px;
  }

  .empty-volunteer{
    margin-top: 10px;
    text-align: center;
    color: #aaa;
  }
</style>

<template>
  <div class="pending-volunteer">
    <div class="pending-volunteer-holder" v-if="pendingVolunteers.careplan_item">
      <h3>Pending Volunteers</h3>
      <div class="empty-volunteer" v-if="pendingVolunteers.careplan_item.length == 0">
        Currently no pending volunteer
      </div>
      <div class="user-volunteer" v-for="volunteer in pendingVolunteers.careplan_item">
        <div class="user-holder">
          <div class="avatar">
            <Avatar shape="square" icon="person" size="large" :src="volunteer.poster.avatar" />
          </div>
          <div class="user-info">
            <h3>{{volunteer.poster.display_name}}</h3>
            <small>Applied for {{getPermissionLabel(volunteer.data.permission)}}</small>
          </div>
        </div>
        <div class="action-buttons">
          <!-- <Button icon="android-close" class="reject"></Button> -->
          <Button icon="android-done" class="accept" v-on:click="acceptVolunteer(volunteer)"></Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'PendingInviteComponent',
    data(){
      return {
        premissions: Cons[0].PERMISSIONS
      }
    },
    computed: {
      pendingVolunteers: {
        get() {
          return this.$store.state.resource.singleResource.pendingVolunteer;
        }
      },
      pendingAcceptLoader: {
        get() {
          return this.$store.state.resource.singleResource.pendingVolunteerLoader;
        }
      }
    },
    methods: {
      getPermissionLabel(value){
        for(let i=0; i<this.premissions.length; i++){
          if(value == this.premissions[i].value){
            return this.premissions[i].label;
          }
        }
      },
      acceptVolunteer(data){
        this.$store.dispatch('resource/acceptPendingVolunteer', { id: data.id, permission: data.data.permission }).then(res => {
          this.$Message({
            closable: true,
            // durationInSec:3,
            title: { content:'Accepted' },
            icon: 'checkmark',
            message: { content: 'User accepted as volunteer' },
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
            ]
          });               
        })
      }
    }
  }
</script>
